import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";
import { WidthMode } from "features/header/headerSlice";

interface StyledBackgroundProps {
  url: string | undefined;
  color: string | undefined;
  headerWidthMode: WidthMode;
}

export default styled.div<StyledBackgroundProps>`
  flex: 1;
  min-height: 100%;
  width: 100%;
  background-position: top;
  background-size: cover;
  background-color: ${({ color }) => color};
  background-image: ${({ url }) => `url(${url})`};
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  transition: background-color 200ms, background-image 200ms;

  @media screen and (min-width: ${DESKTOP}px) {
    width: ${({ headerWidthMode }) =>
      headerWidthMode === "full" ? "100%" : "50%"};
  }
`;
